import clsx from 'clsx';
import Icon from '../Icon/Icon';
import { JobHintProps } from './JobHint.interfaces';
import styles from './JobHint.module.scss';

const JobHint = ({
  variant = 'default',
  hint = 'Unsere Ausschreibung spricht dich sehr an, jedoch erfüllst du nicht ganz die 100 %? Kein Thema - die fehlenden Prozente gehen wir gemeinsam.',
}: JobHintProps) => (
  <div className={clsx(styles.base, styles[variant])}>
    <div className={styles.left}>
      <Icon
        className={styles.icon}
        size="iconSize128"
        variant={'user/high5'}
        isOutlined
      />
    </div>
    <div className={styles.right}>
      <p className={styles.p}>{hint}</p>
    </div>
  </div>
);

export default JobHint;
